// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OnboardingHelpButton.web.old {\n  margin-top: 10px;\n  pointer-events: auto;\n}\n.OnboardingHelpButton.mobile.old {\n  pointer-events: auto;\n  position: fixed;\n  top: 25px;\n  left: 0px;\n  margin-top: -5px;\n  margin-left: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
